import { call, put, select } from 'redux-saga/effects';

import { getOperators } from 'api/methods/common/operators';

import { registerUI, updateUI } from 'bus/ui/actions';
import { commonActions } from 'bus/common/actions';
import { createUi } from 'bus/ui/helpers';

import { GET_OPERATORS_UI } from '../../../constants';

export function* getOperatorsWorker({ payload }) {
  const token = yield select(({ auth }) => auth.get('token'));
  const tfID = yield select(({ auth }) => auth.getIn(['profile', 'tf', 'id']));
  const { queryParams = {} } = payload;

  yield put(registerUI(createUi({ loading: true }), GET_OPERATORS_UI));

  try {
    const { operators, limit, total } = yield call(
      getOperators,
      token,
      { pathParams: { id: tfID }, queryParams }
    );

    yield put(commonActions.getOperatorsMtSuccess(operators));
    yield put(commonActions.setOperatorsPagination(total, limit));
  } catch (error) {
    yield put(commonActions.getOperatorsMtFail(error));
    yield put(updateUI({ message: 'Ошибка сервера', error: true }, GET_OPERATORS_UI));
  } finally {
    yield put(updateUI({ completed: true, loading: false }, GET_OPERATORS_UI));
  }
}
